document.documentElement.classList.add('sn-ready');

const qs = (selector, scope = document) => scope.querySelector(selector);
const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

function updateNavigationOffsets() {
  const header = qs('.site-header');
  if (!header) return;
  const height = Math.ceil(header.getBoundingClientRect().height);
  document.documentElement.style.setProperty('--sn-category-top', `${height}px`);
  document.documentElement.style.setProperty('--sn-mobile-nav-top', `${height}px`);
}

function initMobileMenu() {
  const toggle = qs('.mobile-menu-toggle');
  const nav = qs('#SiteNav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    document.documentElement.classList.toggle('sn-menu-open', !isOpen);
  });

  qsa('a', nav).forEach((link) => {
    link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('sn-menu-open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sn-menu-open');
  });
}

function initPersonalisationPreview() {
  const form = qs('.product-form');
  const preview = qs('[data-preview-text]');
  if (!form || !preview) return;

  const fields = {
    service: qs('#PersonalisationService', form),
    priceNote: qs('#PersonalisationPriceNote', form),
    estimatedCharge: qs('#PersonalisationEstimatedCharge', form),
    design: qs('#PersonalisationDesign', form),
    designSize: qs('#DesignSize', form),
    text: qs('#EmbroideryText', form),
    placement: qs('#EmbroideryPlacement', form),
    colour: qs('#LogoColour', form),
    academy: qs('#AcademyName', form),
    stitches: qs('#EmbroideryStitches', form),
    costOutput: qs('#PersonalisationCostOutput', form),
    notes: qs('#CustomNotes', form),
  };

  const update = () => {
    const lines = [];
    const hasPaidService = Boolean(fields.service?.value);
    const sizeStitchMap = {
      'Small design - estimated 5,000 stitches': 5000,
      'Medium design - estimated 10,000 stitches': 10000,
      'Large design - estimated 15,000 stitches': 15000,
    };
    const manualStitchCount = Math.max(0, Number.parseInt(fields.stitches?.value || '0', 10) || 0);
    const sizeStitchCount = sizeStitchMap[fields.designSize?.value] || 0;
    const stitchCount = manualStitchCount || sizeStitchCount;
    const isEmbroidery = fields.service?.value.toLowerCase().includes('embroidery');
    const calculatedEmbroideryCost = stitchCount > 0 ? Math.max(5, (stitchCount / 1000) * 1.5) : 0;
    const estimatedCost = isEmbroidery
      ? calculatedEmbroideryCost
      : (hasPaidService ? 5 : 0);
    const formattedCost = `£${estimatedCost.toFixed(2)}`;

    if (fields.priceNote) {
      fields.priceNote.disabled = !hasPaidService;
    }

    if (fields.estimatedCharge) {
      fields.estimatedCharge.disabled = !hasPaidService;
      fields.estimatedCharge.value = hasPaidService ? `${formattedCost} estimated extra charge` : '';
    }

    if (fields.costOutput) {
      fields.costOutput.textContent = hasPaidService
        ? `Estimated extra charge: ${formattedCost}${isEmbroidery ? ' at £1.50 / 1,000 stitches' : ' starting price'}`
        : 'Estimated charge: £0.00';
    }

    if (hasPaidService) lines.push(`Service: ${fields.service.value}`);
    if (hasPaidService) lines.push(`Estimated extra charge: ${formattedCost}`);
    if (fields.design?.value) lines.push(`Design: ${fields.design.value}`);
    if (fields.designSize?.value) lines.push(`Design size: ${fields.designSize.value}`);
    if (fields.text?.value.trim()) lines.push(`Text: ${fields.text.value.trim()}`);
    if (fields.placement?.value) lines.push(`Placement: ${fields.placement.value}`);
    if (fields.colour?.value) lines.push(`Colour: ${fields.colour.value}`);
    if (fields.academy?.value.trim()) lines.push(`Academy/team: ${fields.academy.value.trim()}`);
    if (stitchCount > 0) lines.push(`Estimated stitches: ${stitchCount.toLocaleString()}`);
    if (fields.notes?.value.trim()) lines.push(`Notes: ${fields.notes.value.trim()}`);

    preview.textContent = lines.length ? lines.join(' · ') : 'No personalisation added yet.';
    form.classList.toggle('has-personalisation', lines.length > 0);
    form.classList.toggle('has-paid-personalisation', hasPaidService);
  };

  Object.values(fields).forEach((field) => {
    if (!field) return;
    field.addEventListener('input', update);
    field.addEventListener('change', update);
  });

  update();
}

function initFormStates() {
  qsa('form').forEach((form) => {
    form.addEventListener('submit', () => {
      form.classList.add('is-submitting');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateNavigationOffsets();
  initMobileMenu();
  initPersonalisationPreview();
  initFormStates();
});

window.addEventListener('resize', updateNavigationOffsets);
window.addEventListener('load', updateNavigationOffsets);
